import {MechanicLargestArmyPlayerState, MechanicLargestArmyState, PlayerColor} from '@colonist/game-states'
import {MechanicValidator} from './MechanicValidator'
import {PlayerValidator} from '@colonist/game-mechanic-validators'
import {MapValidator} from '../core/map/MapValidator'

export class MechanicValidatorLargestArmy extends MechanicValidator {
    private readonly largestArmyState: MechanicLargestArmyState

    constructor(playerStates: PlayerValidator[], mapValidator: MapValidator, largestArmyState: MechanicLargestArmyState) {
        super(playerStates, mapValidator)

        this.largestArmyState = largestArmyState
    }

    getLargestArmyPlayerState(player: PlayerColor): MechanicLargestArmyPlayerState {
        if(player == PlayerColor.None) return {}

        const largestArmyPlayerState = this.largestArmyState[player]
        if(largestArmyPlayerState === undefined) throw new Error(`No largestArmyPlayerState for player ${player}`)

        return largestArmyPlayerState
    }

    getPlayerWithLargestArmy(): PlayerColor {
        for(const key in this.largestArmyState) {
            const playerColor = Number(key) as PlayerColor
            const largestArmyPlayerState = this.getLargestArmyPlayerState(playerColor)
            if(largestArmyPlayerState.hasLargestArmy) return playerColor
        }
        return PlayerColor.None
    }

    doesBankHaveLargestArmyCard(): boolean {
        const playerWithLargestArmyCard = this.getPlayerWithLargestArmy()
        return playerWithLargestArmyCard == PlayerColor.None
    }
}
